import { EasyFeatureManager } from "helpers/EasyFeatureManager";

const API_URL = process.env.REACT_APP_API_URL;

const STAGING = "https://risedev38001.rwaapps.net:3010";
const UAT = "https://uat.rwaapps.net:3010";
const DEMO = "https://demo.rwaapps.net:3010";
const TEST = "https://test.rwaapps.net:3010";
const PROD = "https://riseapi.rwaapps.net";

// define or import feature flags
const featureFlags = (() => {
	switch (API_URL) {
		case STAGING:
			return {
				fusionAuth: true,
			};

		case UAT:
			return {
				fusionAuth: true,
			};

		case DEMO:
			return {
				fusionAuth: true,
			};

		case TEST:
			return {
				fusionAuth: true,
			};

		case PROD:
			return {
				fusionAuth: true,
			};

		default:
			return {
				fusionAuth: true,
			};
	}
})();

// Register feature manager as a global variable
(window as any).RiseCrm = (window as any).RiseCrm ?? {};
(window as any).RiseCrm.FeatureManager = new EasyFeatureManager(
	featureFlags,
	"2024.11.06",
);

export const FeatureManager = (window as any).RiseCrm.FeatureManager;
